import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN ArticleRow variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */

/**
 * Container styles for the ArticleRow wrapper
 */
export const articleRowContainerVariants = cva('w-full', {
  variants: {
    variant: {
      hero: '',
      '2-col': '',
      '3-col': '',
      '4-col': '',
      carousel: 'relative',
    },
  },
  defaultVariants: {
    variant: '2-col',
  },
});

/**
 * Grid layout styles for article card grids
 */
export const articleRowGridVariants = cva('grid w-full', {
  variants: {
    variant: {
      hero: '',
      '2-col': 'grid-cols-1 md:grid-cols-2 gap-lg',
      '3-col': 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-lg',
      '4-col': 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-lg',
      carousel: '',
    },
  },
  defaultVariants: {
    variant: '2-col',
  },
});

/**
 * Hero overlay content styles
 * Matches Figma design with gradient overlay and centered content
 */
export const heroOverlayVariants = cva(
  [
    // Positioning within ImageCard
    'absolute inset-0',
    // Gradient overlay for text readability
    'bg-gradient-to-t from-black/50 to-transparent',
    // Content layout
    'flex flex-col items-center justify-end',
    // Padding from edges
    'p-d3',
    // Gap between text and button
    'gap-lg',
  ],
  {
    variants: {},
    defaultVariants: {},
  },
);

export type ArticleRowContainerVariantProps = VariantProps<
  typeof articleRowContainerVariants
>;
export type ArticleRowGridVariantProps = VariantProps<
  typeof articleRowGridVariants
>;
export type HeroOverlayVariantProps = VariantProps<typeof heroOverlayVariants>;
